/**
 * Footer Quick Links - remove tabindex from title
 */
(() => {
  const query = document.querySelectorAll('.footer .quicklinks .title');
  if (!query.length) return;

  query.forEach((item) => {
    item.removeAttribute('tabindex');
  });
})();
